export default "/icon_delete.da3ddf71-d24015.png";